/* eslint-disable max-len */
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { RatingsIcon, RatingsWrapper } from '../../common-field-styles';
import { FormContext } from '../../../shared/contexts/form-context';
import { getNumbers, emptyOrNot } from '../../../../shared/utils';
import { setUserInputOnCtrl } from '../../../form/reducer/form';
import { ControlPropType } from '../../ctrl_proptype';

// Extract shape count from value
const getRating = (ctrl, inTable, tr, col) => {
  const value = inTable ? ctrl.value?.[tr - 1]?.[col - 1] : ctrl.value;
  return value ? parseInt(value.replace(/\D/g, ''), 10) : null;
};
export default function HeartRatingSubComponent(props) {
  const dispatch = useDispatch();
  const { ctrl, inTable, col, tr } = props;
  const rating = getRating(ctrl, inTable, tr, col);
  const { inBuilder, inForm, currentPageNo } = useContext(FormContext);
  const columnType = inTable ? ctrl.props.column_types[col - 1] : ctrl.type;
  const heartsCount = inTable ? ctrl.table_props[col - 1].hearts_count : ctrl.props.hearts_count;

  const saveUpdatedCtrl = (newValue) => {
    dispatch(
      setUserInputOnCtrl({
        newValue,
        isValid: true,
        property: 'value',
        page: currentPageNo - 1,
        ctrlId: ctrl.internal_id,
        ...(inTable && { tr: tr - 1, col: col - 1 }),
      })
    );
  };

  const handleShapeClick = (index) => {
    if (!inForm) return;
    const newRating = index + 1;
    const newRatingString = `${newRating} Heart${newRating > 1 ? 's' : ''}`;
    saveUpdatedCtrl(rating !== newRating ? newRatingString : null);
  };

  return (
    <RatingsWrapper notInBuilder={!inBuilder} id={inTable ? `fpl-${col}-${tr}` : `fpl-${ctrl.internal_id}`}>
      {getNumbers(heartsCount).map((no, idx) => (
        <RatingsIcon
          tabIndex="0"
          key={`heart-${no}`}
          onClick={() => handleShapeClick(idx)}
          className={`heart big icon ${emptyOrNot(columnType, idx, rating)}`}
        />
      ))}
    </RatingsWrapper>
  );
}

HeartRatingSubComponent.defaultProps = {
  tr: null,
  col: null,
  inTable: false,
};

HeartRatingSubComponent.propTypes = {
  tr: PropTypes.number,
  col: PropTypes.number,
  inTable: PropTypes.bool,
  ctrl: PropTypes.shape(ControlPropType).isRequired,
};
